module.exports = __webpack_public_path__ + "img/logo_white.911b2563.png";